import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Button,
  VStack,
  HStack,
  Divider,
  ModalBody,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from 'ui';
import {
  TextField,
  SelectField,
} from '@components/Form/Field';
import { ZIP_CODE_LENGTH } from '@config/index';
import { ts } from './utils';
import { useController } from './hooks';
import { style as s } from './AddressFormModal.style';

export const AddressFormModal = (props) => {
  const {
    isOpen,
    onCloseModal,
    onCompleted,
    address,
  } = props;

  const {
    control,
    zipError,
    onSubmit,
    isSubmitting,
    neighborhoods,
  } = useController({
    onCompleted,
    onCloseModal,
    address,
  });

  return (
    <Modal isOpen={isOpen} onClose={onCloseModal} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader {...s.header}>{ts('title')}</ModalHeader>
        <Divider />
        <ModalCloseButton />
        <ModalBody>
          <VStack>
            <TextField
              name="street"
              data-testid="streetField"
              control={control}
              labelText={ts('streetLabel')}
            />
            <HStack {...s.numberFields}>
              <TextField
                control={control}
                name="extNumber"
                data-testid="extNumberField"
                maxLength={10}
                labelText={ts('extNumberLabel')}
              />
              <TextField
                control={control}
                name="intNumber"
                data-testid="intNumberField"
                maxLength={10}
                labelText={ts('intNumberLabel')}
              />
            </HStack>
            <TextField
              name="zip"
              type="number"
              data-testid="zipField"
              control={control}
              labelText={ts('zipLabel')}
              maxLength={ZIP_CODE_LENGTH}
            />
            <SelectField
              labelText={ts('neighborhoodLabel')}
              placeholder={ts('neighborhoodPlaceholder')}
              control={control}
              name="neighborhood"
              data-testid="neighborhoodField"
              isDisabled={!neighborhoods}
            >
              {neighborhoods?.map(
                (item) => <option value={item} key={item}>{item}</option>,
              )}
            </SelectField>
            <TextField
              control={control}
              name="municipality"
              data-testid="municipalityField"
              labelText={ts('municipalityLabel')}
              isReadOnly
              isDisabled
            />
            <TextField
              control={control}
              name="city"
              data-testid="cityField"
              labelText={ts('cityLabel')}
              isReadOnly
              isDisabled
            />
            <TextField
              control={control}
              name="stateName"
              data-testid="stateNameField"
              labelText={ts('stateNameLabel')}
              isReadOnly
              isDisabled
            />
          </VStack>
          <HStack>
            <Button
              {...s.buttons}
              onClick={onCloseModal}
              variant="ghost"
            >
              {ts('cancel')}
            </Button>
            <Button
              {...s.buttons}
              onClick={onSubmit}
              isDisabled={zipError || isSubmitting}
            >
              {ts('save')}
            </Button>
          </HStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

AddressFormModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onCompleted: PropTypes.func,
};

AddressFormModal.defaultProps = {
  onCompleted: () => { },
};
